var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['lp-container', {'padding-has-caution': _vm.isHasCaution}]},[(_vm.detailLP)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.detailLP.content)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }